import { ActionExtended } from "src/_common/interfaces/ActionExtended";
import { ACTIONS } from "src/_config";
export interface EventReducer {
  getEventList: any;
  getPerformanceList: any;
  getEventGameList: any;
  getEventGameDetails: any;
  getEventStatusMessage: any;
  getIrStatusMessage: any;
  getLeaderBoard: any;
  getTvImageDetails: any;
  getWiningTruckDetails: any;
  winingTruckModalShow: boolean;
  fromRoute: any;
  pick_id: any;
  login_required: number;
  site_header: any;
  gameDetails: any;
  rodeoEventSettings: any;
}

const initialState: EventReducer = {
  getEventList: null,
  getPerformanceList: null,
  getEventGameList: null,
  getEventGameDetails: null,
  getEventStatusMessage: null,
  getIrStatusMessage: null,
  getLeaderBoard: null,
  getTvImageDetails: null,
  getWiningTruckDetails: null,
  winingTruckModalShow: false,
  fromRoute: null,
  pick_id: null,
  login_required: 0,
  site_header: null,
  gameDetails: null,
  rodeoEventSettings: null,
};

const eventReducer = (state = initialState, action: ActionExtended) => {
  switch (action.type) {
    case ACTIONS.EVENT.GET_EVENT_LIST:
      return {
        ...state,
        getEventList: action.payload,
      };
    case ACTIONS.EVENT.GET_PERFORMANCE_LIST:
      return {
        ...state,
        getPerformanceList: action.payload,
      };
    case ACTIONS.EVENT.GET_EVENT_GAME:
      return {
        ...state,
        getEventGameList: action.payload,
      };
    case ACTIONS.EVENT.GET_EVENT_GAME_DETAILS:
      return {
        ...state,
        getEventGameDetails: action.payload,
      };
    case ACTIONS.EVENT.GET_STATUS_MESSAGE:
      return {
        ...state,
        getEventStatusMessage: action.payload,
      };
    case ACTIONS.EVENT.LEADERBOARD:
      return {
        ...state,
        getLeaderBoard: action.payload,
      };
    case ACTIONS.TV_IMAGE.DETAILS:
      return {
        ...state,
        getTvImageDetails: action.payload,
      };
    case ACTIONS.EVENT.OPEN_WINING_MODAL:
      return {
        ...state,
        winingTruckModalShow: action.payload,
      };
    case ACTIONS.EVENT.NEXT_EVENT_FROM_ROUTE:
      return {
        ...state,
        fromRoute: action.payload,
      };
    case ACTIONS.EVENT.SET_PICK_ID:
      // if(action.payload.length)
      let pickId = [];
      pickId = state.pick_id;
      if (pickId) {
        pickId.push(action.payload);
      } else {
        pickId = [action.payload];
      }
      // console.log(pickId)
      return {
        ...state,
        pick_id: pickId,
      };
    case ACTIONS.EVENT.RESET_PICK_ID:
      return {
        ...state,
        pick_id: null,
      };
    case ACTIONS.EVENT.RODEO_EVENT_LOGIN_REQUIRED:
      return {
        ...state,
        login_required: action.payload,
      };
    case ACTIONS.EVENT.SITE_HEADER:
      return {
        ...state,
        site_header: action.payload,
      };

    //Update rider vote details
    case ACTIONS.EVENT.GET_SOCKET_RIDER_WITH_VOTE_DETAILS:
      var { socketData } = action.payload;
      let gameDetailsForRider = state.getEventGameDetails;
      if (
        gameDetailsForRider &&
        gameDetailsForRider.events &&
        gameDetailsForRider.events.id === socketData.rodeo_event_event_id
      ) {
        gameDetailsForRider.events.riders = socketData.riders;
      }

      return {
        ...state,
        getEventGameDetails: {
          ...gameDetailsForRider,
        },
      };

    // Update Game Status at Event game list page
    case ACTIONS.EVENT.GET_SOCKET_START_DATA_AND_PUSH_TO_GAME_LIST:
      var { socketData } = action.payload;
      let eventList = state.getEventGameList;
      if (eventList && eventList.length) {
        var findGameIndex = eventList.findIndex((x: any) => x.id === socketData.id);
        if (findGameIndex >= 0) {
          eventList[findGameIndex].status = socketData.status;
        }
      }

      return {
        ...state,
        getEventGameList: eventList && eventList.length ? eventList.map((x: any) => Object.assign(x)) : [],
      };

    //Update game event details data
    case ACTIONS.EVENT.GET_SOCKET_START_DATA_AND_PUSH_TO_GAME_DETAILS:
      var { socketData } = action.payload;
      let gameDetails = state.getEventGameDetails;
      if (gameDetails && gameDetails.events && gameDetails.events.id == socketData.id) {
        gameDetails.events.status = socketData.status;
      }
      return {
        ...state,
        getEventGameDetails: {
          ...gameDetails,
        },
      };

    case ACTIONS.EVENT.UPDATE_EVENT_DETAILS_TIE_BREAKER_CODE:
      let event_dtls = state.getEventGameDetails;
      event_dtls.events.user_tiebreaker_details = { code: action.payload };

      return {
        ...state,
        getEventGameDetails: {
          ...event_dtls,
        },
      };

    //Update game event details user answer data
    case ACTIONS.EVENT.UPDATE_EVENT_DETAILS_USER_ANSWER_DATA:
      var data = action.payload;
      var eventDetails = state.getEventGameDetails;
      let userAnswer: any = [];
      console.log(">>>>>>>>>>><<<<<<", { data });
      if (data.editAnswer && eventDetails?.events?.user_answers?.length) {
        console.log("11111", { eventDetails });
        userAnswer = eventDetails.events.user_answers?.map((x: any) => {
          if (x.question_id == data.question_id) {
            return data;
          } else {
            return x;
          }
        });
      } else if (!data.editAnswer) {
        console.log("333333", { eventDetails });
        userAnswer = eventDetails?.events?.user_answers?.length ? eventDetails.events.user_answers : [];
        userAnswer.push(data);
      }
      let found = eventDetails?.events?.user_answers?.find((x: any) => x.question_id == data.question_id);
      if (!found && data.editAnswer) {
        userAnswer.push(data);
      }
      console.log({ userAnswer });

      return {
        ...state,
        getEventGameDetails: {
          ...eventDetails,
          events: { ...eventDetails.events, user_answers: userAnswer },
        },
      };

    //Update game event details user answer data
    case ACTIONS.EVENT.UPDATE_EVENT_DETAILS_USER_ANSWER_WINNER_DATA:
      var data = action.payload;
      var eventDetails = state.getEventGameDetails;
      let userAnswerWinner: any = [];
      if (eventDetails?.events?.questions_dtls?.length) {
        userAnswerWinner = eventDetails?.events?.questions_dtls?.map((x: any) => {
          if (x.id == data?.answer_contestant_details?.question_id) {
            let f = 0;
            var ans = x?.answer_cont_dtls?.map((a: any) => {
              if (a.id == data?.answer_contestant_details?.id) {
                f = 1;
                return { ...a, is_winner: data?.answer_contestant_details?.is_winner };
              } else {
                return { ...a, is_winner: 0 };
                // return a;
              }
            });
            return { ...x, answer_cont_dtls: ans, winning_declare: f };
          } else {
            return x;
          }
        });
      }
      console.log({ data, eventDetails, userAnswerWinner });
      return {
        ...state,
        getEventGameDetails: {
          ...eventDetails,
          events: { ...eventDetails.events, questions_dtls: userAnswerWinner },
        },
      };

    //Update game status message
    case ACTIONS.EVENT.GET_SOCKET_STATUS_MESSAGE_AND_PUSH_TO_STATUS_LIST:
      var { socketData } = action.payload;
      let statusMessageList = state.getEventStatusMessage;
      if (statusMessageList && statusMessageList.length) {
        statusMessageList.map((x: any, index: number) => {
          if (x.rodeo_event_id === socketData.rodeo_event_id) {
            statusMessageList[index].status_text = socketData.status_text;
          }
        });
      } else {
        statusMessageList.push(socketData);
      }
      return {
        ...state,
        getEventStatusMessage:
          statusMessageList && statusMessageList.length ? statusMessageList.map((x: any) => Object.assign(x)) : [],
      };

    case ACTIONS.EVENT.GET_IR_STATUS_MESSAGE:
      let y: any = null;
      // if(action.payload && action.payload.status_text) {
      if (action.payload) {
        y = action.payload.status_text;
      }
      return {
        ...state,
        getIrStatusMessage: y,
      };

    //Update wining truck details
    case ACTIONS.EVENT.GET_WINING_SOCKET_DATA_AND_PUSH_TO_WINING_DETAILS:
      var { socketData } = action.payload;
      let gameDetailsPage = state.getEventGameDetails;
      let winingData = null;
      let isWiningModalShow: boolean = false;
      if (socketData && socketData.event_dtls) {
        // If socket data && inside data event details exist
        if (gameDetailsPage && gameDetailsPage.event_dtls && gameDetailsPage.event_dtls.isjoined) {
          // If current user joined that game
          if (
            gameDetailsPage &&
            gameDetailsPage.event_dtls &&
            gameDetailsPage.event_dtls.id === socketData.event_dtls.id
          ) {
            //if socket game id equals to user stay on page game id
            if (gameDetailsPage.event_dtls.status === 2 && socketData.event_dtls.status === 2) {
              // if game status is end, 0 => Not started, 1=> Ongoing, 2=> End
              winingData = socketData;
              isWiningModalShow = true;
              gameDetailsPage.event_dtls.winning = {
                //Update Wining Reducer data
                event_id: socketData.event_dtls.id,
                rodeo_event_id: socketData.event_dtls.rodeo_event_id,
                truck_id: socketData.truck.id,
              };
            }
          }
        } else {
          if (gameDetailsPage && gameDetailsPage.event_dtls && !gameDetailsPage.event_dtls.isjoined) {
            // If current user not joined that game
            if (
              gameDetailsPage &&
              gameDetailsPage.event_dtls &&
              gameDetailsPage.event_dtls.id === socketData.event_dtls.id
            ) {
              //if socket game id equals to user stay on page game id
              if (gameDetailsPage.event_dtls.status === 2 && socketData.event_dtls.status === 2) {
                // if game status is end, 0 => Not started, 1=> Ongoing, 2=> End
                gameDetailsPage.event_dtls.winning = {
                  //Update Wining Reducer data
                  event_id: socketData.event_dtls.id,
                  rodeo_event_id: socketData.event_dtls.rodeo_event_id,
                  truck_id: socketData.truck.id,
                };
              }
            }
          }
        }
      }
      return {
        ...state,
        getWiningTruckDetails: winingData ? { ...winingData } : null,
        winingTruckModalShow: isWiningModalShow ? isWiningModalShow : false,
        getEventGameDetails: {
          ...gameDetailsPage,
        },
      };

    case ACTIONS.EVENT.GET_EVENT_LIST_GLOWING_SOCKET:
      var { socketData } = action.payload;
      let getEventListData = state.getEventList?.list;
      if (getEventListData && getEventListData.length) {
        var findEventIndex = getEventListData.findIndex((x: any) => x.id == socketData.settings.rodeo_event_id);
        console.log({ findEventIndex, socketData });
        if (findEventIndex >= 0) {
          // getEventListData[findEventIndex].currently_ongoing = socketData.check_ongoing_event
          getEventListData[findEventIndex].rodeo_event_game_info.is_event_glow = socketData.settings.is_event_glow;
        }
      }
      return {
        ...state,
        getEventList: {
          ...state.getEventList,
          list: getEventListData && getEventListData.length ? getEventListData.map((x: any) => Object.assign(x)) : [],
        },
      };
    case ACTIONS.EVENT.GET_GAME_DETAILS:
      return {
        ...state,
        gameDetails: action.payload,
      };

    case ACTIONS.EVENT.RODEO_EVENT_SETTINGS:
      return {
        ...state,
        rodeoEventSettings: action.payload,
      };

    case ACTIONS.EVENT.SET_EVENT_IS_PICKED:
      let event_id = action.payload.event_id;
      // let performance_id=action.payload.performance_id
      // let rodeo_event_id=action.payload.rodeo_event_id
      let eventGameList = state.getEventGameList;
      // console.log("1",eventGameList,action.payload)
      if (eventGameList && eventGameList.length) {
        var findGameIndex = eventGameList.findIndex((x: any) => {
          // console.log({x},x.id, event_id, x.id == event_id)
          return x.id == event_id;
        });
        // console.log("2", findGameIndex)
        if (findGameIndex >= 0) {
          // console.log("3", findGameIndex, action.payload)
          eventGameList[findGameIndex].ispicked = action.payload;
        }
      }

      return {
        ...state,
        getEventGameList: eventGameList,
      };
    case ACTIONS.EVENT.EMPTY_USER_ANSWERS:
      return {
        ...state,
        getEventGameDetails: {
          ...state.getEventGameDetails,
          events: {
            ...state.getEventGameDetails.events,
            user_answers: [],
          },
        },
      };
    default:
      return state;
  }
};

export default eventReducer;
